import { render, staticRenderFns } from "./Confounder.vue?vue&type=template&id=331c0408&"
import script from "./Confounder.vue?vue&type=script&lang=js&"
export * from "./Confounder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports